import {
  DATASTRATEGY,
  IEntityManagerConfiguration,
} from '@proximus/entity-manager';
import { SessionStorageStrategy } from '@proximus/entity-manager/lib/storage/strategies/session-storage.strategy';
import { LocalForageStrategy } from '@proximus/entity-manager/lib/storage/strategies/local-forage.strategy';
import { CryptoJsProviderStrategy } from '@proximus/entity-manager/lib/encryption/cryptoJsProviderStrategy';

const MyMailConfig: IEntityManagerConfiguration = {
  application: {
    applicationName: 'myMail',
    applicationVersion: '0.0.1',
    versionStorageStrategyId: LocalForageStrategy.ID,
    clearStorageIfVersionIsMissing: false,
  },
  storageStrategies: {
    localForage: new LocalForageStrategy(),
    sessionStorage: new SessionStorageStrategy(),
  },
  selectedEncryptionStrategy: CryptoJsProviderStrategy(),
  timeout: 10000,
  language: {
    selectLanguageFunction: () => (window as any).language || 'en',
    languageStorageStrategyId: LocalForageStrategy.ID,
  },
  defaultEntityConfiguration: {
    version: 'v1',
    dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
    storageStrategy: LocalForageStrategy.ID,
  },
  jwtStorageStrategyId: SessionStorageStrategy.ID,
  onErrorCallback: () => {},
};

export const RootPages = [
  {
    label: 'breadcrumb.myProducts.label',
    url: 'breadcrumb.myProducts.url',
  },
];

export const DefaultMailboxDomain = 'proximus.be';

export const ProximusMailboxPattern =
  '^(?!(?:[a-z]{2}[0-9]{6})$)(?=(.*[a-zA-Z]){2})(([a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)*))*$';

export { MyMailConfig };
